// @tennis-matches/clubmeisterschaft-core/results – parts to canonical result (pure)

/**
 * Minimal v1: TWO_SETS (oder ONE_SET) reicht.
 * Wir speichern:
 * - setsA/setsB (Anzahl gewonnener Sätze)
 * - gamesA/gamesB (Summe Games, optional)
 *
 * parts expected:
 * s1a,s1b,s2a,s2b,s3a,s3b (optional)
 */
export function partsToResult(parts) {
  const p = parts && typeof parts === "object" ? parts : {};
  const pairs = [
    [num(p.s1a), num(p.s1b)],
    [num(p.s2a), num(p.s2b)],
    [num(p.s3a), num(p.s3b)],
  ].filter(([a, b]) => a !== null || b !== null);

  if (pairs.length === 0) return null;

  let setsA = 0;
  let setsB = 0;
  let gamesA = 0;
  let gamesB = 0;

  for (const [a0, b0] of pairs) {
    const a = a0 ?? 0;
    const b = b0 ?? 0;
    gamesA += a;
    gamesB += b;
    if (a > b) setsA++;
    else if (b > a) setsB++;
  }

  return { setsA, setsB, gamesA, gamesB };
}

function num(v) {
  if (v === "" || v === undefined || v === null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}
